import type { RespostasPersonalizadasIzzaModel } from "../models/respostasPersonalizadasIzzaModel"
import { RespostasPersonalizadasIzzaInicial } from "../models/respostasPersonalizadasIzzaModel"
import type { RespostasPersonalizadasIzzaActionModel } from "./respostasPersonalizadasIzzaActions"
import { RespostasPersonalizadasIzzaActionsTypes } from "./respostasPersonalizadasIzzaActions"

export function respostasPersonalizadasIzzaReducer(
    state: RespostasPersonalizadasIzzaModel = RespostasPersonalizadasIzzaInicial,
    action: RespostasPersonalizadasIzzaActionModel
): RespostasPersonalizadasIzzaModel {
    switch (action.type) {
        case RespostasPersonalizadasIzzaActionsTypes.CARREGAR:
            return { ...action.payload }

        case RespostasPersonalizadasIzzaActionsTypes.ATUALIZAR_RESPOSTA:
            return {
                ...state,
                [action.payload.campo]: {
                    ...state[action.payload.campo],
                    resposta: action.payload.resposta,
                },
            }

        case RespostasPersonalizadasIzzaActionsTypes.TOGGLE_ATIVO:
            return {
                ...state,
                [action.payload.campo]: {
                    ...state[action.payload.campo],
                    ativo: !state[action.payload.campo].ativo,
                },
            }

        default:
            return state
    }
}
